module.exports = __webpack_public_path__ + "static/fathomIcon1-e98a5c87513683fcfc6600a3e8122a19.svg";